(function(){
  var KEY = 'bkBacciArtVault';
  var LEGACY_KEY = 'bk_hx_museum';

  function safeParse(raw, fallback){
    try {
      return raw ? JSON.parse(raw) : fallback;
    } catch(e) {
      return fallback;
    }
  }

  function uid(){
    return 'bk-art-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,8);
  }

  function read(){
    var list = safeParse(localStorage.getItem(KEY), []);
    return Array.isArray(list) ? list : [];
  }

  function write(list){
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(-40)));
      return true;
    } catch(e) {
      try {
        localStorage.setItem(KEY, JSON.stringify(list.slice(-18)));
        return true;
      } catch(e2) {
        return false;
      }
    }
  }

  function normalize(item){
    if(!item) return null;

    var img = item.imageData || item.thumb || item.image || item.dataUrl || '';

    if(!img) return null;

    return {
      artId: item.artId || uid(),
      sourceSystem: item.sourceSystem || 'heartopedia',
      sourceTier: item.sourceTier || item.tier || 'unknown',
      sourceHub: item.sourceHub || item.hub || 'heartopedia',
      title: item.title || item.word || 'Heartopedia Art',
      feelingWord: item.feelingWord || item.word || item.title || 'Feeling',
      artistName: item.artistName || item.name || '',
      giftFor: item.giftFor || item.forName || '',
      imageData: img,
      createdAt: item.createdAt || item.when || new Date().toISOString(),
      frameId: item.frameId || '',
      museumPlacements: item.museumPlacements || [],
      rewards: item.rewards || []
    };
  }

  function save(item){
    var next = normalize(item);

    if(!next) {
      return {
        ok: false,
        reason: 'missing-image'
      };
    }

    var list = read();

    list = list.filter(function(x){
      return x.artId !== next.artId;
    });

    list.push(next);

    return {
      ok: write(list),
      item: next,
      count: list.length
    };
  }

  function remove(artId){
    var list = read().filter(function(x){
      return x.artId !== artId;
    });

    return write(list);
  }

  function importLegacy(){
    var legacy = safeParse(localStorage.getItem(LEGACY_KEY), []);

    if(!Array.isArray(legacy) || !legacy.length) {
      return {
        ok: true,
        imported: 0
      };
    }

    var existing = read();
    var count = 0;

    legacy.forEach(function(p){
      if(!p || !p.thumb) return;

      var duplicate = existing.some(function(x){
        return x.imageData === p.thumb;
      });

      if(duplicate) return;

      existing.push(normalize({
        sourceTier: 'legacy',
        sourceHub: 'heartopedia',
        title: 'Heartopedia Museum Art',
        feelingWord: 'Heartopedia',
        artistName: p.name || '',
        imageData: p.thumb,
        createdAt: p.when || Date.now(),
        museumPlacements: [
          {
            room: p.room || 'legacy'
          }
        ]
      }));

      count++;
    });

    write(existing.filter(Boolean));

    return {
      ok: true,
      imported: count
    };
  }

  window.BKArtVault = {
    key: KEY,
    read: read,
    write: write,
    save: save,
    remove: remove,
    importLegacy: importLegacy,
    normalize: normalize
  };
})();